export const META_SIGNUP_COMPLETE_COOKIE = "foundry_meta_signup_complete";

export const META_EVENTS = {
  FREE_NICHE_STARTED: "FreeNicheStarted",
  NICHE_STARTED: "NicheStarted",
  NICHE_STARTED_INTENT: "NicheStartedIntent",
  COMPLETE_NICHE: "CompleteNiche",
  SIGN_UP: "SignUp",
  COMPLETE_REGISTRATION: "CompleteRegistration",
  LEAD: "Lead",
  PURCHASE: "Purchase",
} as const;

export type MetaEventName = (typeof META_EVENTS)[keyof typeof META_EVENTS];

export interface MetaBrowserEvent {
  eventName: MetaEventName;
  eventId: string;
}

export interface MetaGenerationEvents {
  freeNicheStarted?: MetaBrowserEvent;
  lead?: MetaBrowserEvent;
  nicheStarted?: MetaBrowserEvent;
}

export interface MetaSignupCookiePayload {
  signUp?: MetaBrowserEvent;
  completeRegistration?: MetaBrowserEvent;
}
